module.exports = __webpack_public_path__ + "assets/img/btn-more-0089652e.png";